import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { useToast } from '@vnetwork/ui/feedback';
import { useCreateIamUser, s3ExtractError } from '@/api/s3';
import { IamNameCreateForm } from '../IamNameCreateForm';

/** Create an IAM user — name only, validated client-side. */
export function UserCreate({ serviceId }: { serviceId: string }) {
  const navigate = useNavigate();
  const toast = useToast();
  const create = useCreateIamUser(serviceId);
  const listPath = `/services/oss/${serviceId}/iam/users`;

  return (
    <IamNameCreateForm
      title="Create user"
      description="Add an IAM user to this storage service."
      label="User name"
      placeholder="e.g. media-uploader"
      icon={<Users size={22} />}
      submitLabel="Create user"
      pending={create.isPending}
      onCancel={() => navigate(listPath)}
      onSubmit={(name) =>
        create.mutate(name, {
          onSuccess: () => {
            toast.success('User created');
            navigate(listPath);
          },
          onError: (e) => toast.error(s3ExtractError(e, 'Failed to create user')),
        })
      }
    />
  );
}
